/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import ExampleLoading from 'react-scale/components/website/index/Products/examples/exampleLoading';

const TaskResponsePolygonAnnotation = dynamic(
  () => import('react-scale/components/website/index/Products/examples/tasks/polygonannotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

const response = {
  annotations: [
    {
      key: '789ba003-f51c-4a91-bd2a-4dc01c581dac',
      vertices: [
        {
          x: 214.80072962204355,
          y: 1200
        },
        {
          x: 0,
          y: 1200
        },
        {
          x: 0,
          y: 1038.0375
        },
        {
          x: 2.4,
          y: 1018.8375
        },
        {
          x: 4.8,
          y: 1002.8375
        },
        {
          x: 9.6,
          y: 986.0375
        },
        {
          x: 15.2,
          y: 968.4375
        },
        {
          x: 24.8,
          y: 944.4375
        },
        {
          x: 37.6,
          y: 915.01875
        },
        {
          x: 45.6,
          y: 899.41875
        },
        {
          x: 49.2,
          y: 893.81875
        },
        {
          x: 56.8,
          y: 889.01875
        },
        {
          x: 61.6,
          y: 887.41875
        },
        {
          x: 68.4,
          y: 886.61875
        },
        {
          x: 68.4,
          y: 879.01875
        },
        {
          x: 46,
          y: 772.21875
        },
        {
          x: 31.6,
          y: 766.61875
        },
        {
          x: 26.4,
          y: 760.61875
        },
        {
          x: 20.8,
          y: 751.01875
        },
        {
          x: 16,
          y: 739.01875
        },
        {
          x: 13.6,
          y: 723.41875
        },
        {
          x: 12.4,
          y: 704.21875
        },
        {
          x: 13.6,
          y: 533.81875
        },
        {
          x: 14.8,
          y: 523.81875
        },
        {
          x: 20.4,
          y: 512.21875
        },
        {
          x: 24,
          y: 505.81875
        },
        {
          x: 40.8,
          y: 473.41875
        },
        {
          x: 64.8,
          y: 436.21875
        },
        {
          x: 75.6,
          y: 423.41875
        },
        {
          x: 82.8,
          y: 418.61875
        },
        {
          x: 90.4,
          y: 415.81875
        },
        {
          x: 106,
          y: 415.01875
        },
        {
          x: 123.6,
          y: 414.61875
        },
        {
          x: 136,
          y: 414.61875
        },
        {
          x: 145.6,
          y: 415.01875
        },
        {
          x: 154.8,
          y: 419.41875
        },
        {
          x: 170.4,
          y: 430.61875
        },
        {
          x: 175.6,
          y: 436.21875
        },
        {
          x: 178.8,
          y: 439.01875
        },
        {
          x: 204,
          y: 483.41875
        },
        {
          x: 209.2,
          y: 487.01875
        },
        {
          x: 218.8,
          y: 489.41875
        },
        {
          x: 233.2,
          y: 508.21875
        },
        {
          x: 237.6,
          y: 520.61875
        },
        {
          x: 236.8,
          y: 533.81875
        },
        {
          x: 236.4,
          y: 538.61875
        },
        {
          x: 240,
          y: 543.01875
        },
        {
          x: 241.2,
          y: 547.01875
        },
        {
          x: 240.4,
          y: 555.01875
        },
        {
          x: 271.2,
          y: 607.01875
        },
        {
          x: 276,
          y: 613.01875
        },
        {
          x: 280.8,
          y: 615.41875
        },
        {
          x: 287.2,
          y: 620.21875
        },
        {
          x: 349.6,
          y: 748.21875
        },
        {
          x: 352,
          y: 751.81875
        },
        {
          x: 356.4,
          y: 753.01875
        },
        {
          x: 378,
          y: 754.21875
        },
        {
          x: 377.2,
          y: 759.41875
        },
        {
          x: 379.6,
          y: 761.81875
        },
        {
          x: 399.6,
          y: 761.81875
        },
        {
          x: 400.8,
          y: 763.01875
        },
        {
          x: 402,
          y: 768.61875
        },
        {
          x: 411.6,
          y: 768.61875
        },
        {
          x: 424,
          y: 768.61875
        },
        {
          x: 488.8,
          y: 769.81875
        },
        {
          x: 496,
          y: 769.01875
        },
        {
          x: 499.2,
          y: 771.41875
        },
        {
          x: 499.6,
          y: 815.81875
        },
        {
          x: 496,
          y: 816.61875
        },
        {
          x: 420,
          y: 817.81875
        },
        {
          x: 415.6,
          y: 821.81875
        },
        {
          x: 413.2,
          y: 826.21875
        },
        {
          x: 402,
          y: 827.81875
        },
        {
          x: 383.2,
          y: 827.81875
        },
        {
          x: 379.2,
          y: 828.61875
        },
        {
          x: 379.6,
          y: 832.61875
        },
        {
          x: 352,
          y: 834.61875
        },
        {
          x: 350.4,
          y: 839.41875
        },
        {
          x: 347.2,
          y: 845.81875
        },
        {
          x: 338.8,
          y: 851.81875
        },
        {
          x: 331.2,
          y: 854.21875
        },
        {
          x: 322,
          y: 854.21875
        },
        {
          x: 312.4,
          y: 854.21875
        },
        {
          x: 301.6,
          y: 853.01875
        },
        {
          x: 294.4,
          y: 850.21875
        },
        {
          x: 287.2,
          y: 844.21875
        },
        {
          x: 282.4,
          y: 838.61875
        },
        {
          x: 271.2,
          y: 825.01875
        },
        {
          x: 252,
          y: 800.21875
        },
        {
          x: 232,
          y: 773.41875
        },
        {
          x: 224.4,
          y: 760.61875
        },
        {
          x: 222.4,
          y: 768.61875
        },
        {
          x: 223.6,
          y: 773.81875
        },
        {
          x: 228,
          y: 779.81875
        },
        {
          x: 229.2,
          y: 793.81875
        },
        {
          x: 230.8,
          y: 828.61875
        },
        {
          x: 230.8,
          y: 862.21875
        },
        {
          x: 232.8,
          y: 895.01875
        },
        {
          x: 244.8,
          y: 899.81875
        },
        {
          x: 256,
          y: 909.01875
        },
        {
          x: 260.8,
          y: 917.81875
        },
        {
          x: 264.4,
          y: 937.01875
        },
        {
          x: 265.2,
          y: 945.41875
        },
        {
          x: 258.4,
          y: 965.41875
        },
        {
          x: 243.6,
          y: 1000.61875
        },
        {
          x: 235.6,
          y: 1023.41875
        },
        {
          x: 238,
          y: 1026.61875
        },
        {
          x: 237.6,
          y: 1033.01875
        },
        {
          x: 229.6,
          y: 1071.01875
        },
        {
          x: 225.6,
          y: 1097.81875
        },
        {
          x: 222.4,
          y: 1114.21875
        },
        {
          x: 217.6,
          y: 1116.61875
        },
        {
          x: 212.8,
          y: 1117.81875
        },
        {
          x: 215.2,
          y: 1119.41875
        }
      ],
      label: 'robot blank',
      complete: true
    },
    {
      key: 'be7416ed-6074-4461-aa7c-bc33fffba80a',
      vertices: [
        {
          x: 820.8571428571429,
          y: 510.0267857142857
        },
        {
          x: 791.1428571428571,
          y: 510.0267857142857
        },
        {
          x: 790,
          y: 514.0267857142857
        },
        {
          x: 790,
          y: 522.5982142857143
        },
        {
          x: 788.2857142857143,
          y: 524.3125
        },
        {
          x: 765.4285714285714,
          y: 526.0267857142857
        },
        {
          x: 763.7142857142857,
          y: 523.7410714285714
        },
        {
          x: 755.1428571428571,
          y: 523.7410714285714
        },
        {
          x: 754,
          y: 519.1696428571429
        },
        {
          x: 719.7142857142857,
          y: 519.1696428571429
        },
        {
          x: 720.8571428571429,
          y: 525.4553571428571
        },
        {
          x: 723.1428571428571,
          y: 538.0267857142857
        },
        {
          x: 723.1428571428571,
          y: 546.0267857142857
        },
        {
          x: 723.1428571428571,
          y: 553.4553571428571
        },
        {
          x: 722.5714285714286,
          y: 558.0267857142857
        },
        {
          x: 728.2857142857143,
          y: 558.5982142857143
        },
        {
          x: 728.2857142857143,
          y: 570.0267857142857
        },
        {
          x: 724.8571428571429,
          y: 570.5982142857143
        },
        {
          x: 722.5714285714286,
          y: 573.4553571428571
        },
        {
          x: 723.1428571428571,
          y: 582.0267857142857
        },
        {
          x: 724.8571428571429,
          y: 584.3125
        },
        {
          x: 726,
          y: 599.7410714285714
        },
        {
          x: 723.1428571428571,
          y: 600.8839285714286
        },
        {
          x: 723.1428571428571,
          y: 606.0267857142857
        },
        {
          x: 719.7142857142857,
          y: 606.5982142857143
        },
        {
          x: 716.2857142857143,
          y: 606.5982142857143
        },
        {
          x: 716.2857142857143,
          y: 603.1696428571429
        },
        {
          x: 718,
          y: 600.8839285714286
        },
        {
          x: 714,
          y: 596.3125
        },
        {
          x: 712.8571428571429,
          y: 592.3125
        },
        {
          x: 712.2857142857143,
          y: 580.8839285714286
        },
        {
          x: 714.5714285714286,
          y: 579.1696428571429
        },
        {
          x: 715.7142857142857,
          y: 575.7410714285714
        },
        {
          x: 714,
          y: 571.7410714285714
        },
        {
          x: 695.7142857142857,
          y: 568.8839285714286
        },
        {
          x: 690,
          y: 567.1696428571429
        },
        {
          x: 688.8571428571429,
          y: 560.3125
        },
        {
          x: 690,
          y: 544.8839285714286
        },
        {
          x: 679.7142857142857,
          y: 544.8839285714286
        },
        {
          x: 668.2857142857143,
          y: 541.4553571428571
        },
        {
          x: 663.1428571428571,
          y: 544.3125
        },
        {
          x: 658,
          y: 547.7410714285714
        },
        {
          x: 647.7142857142857,
          y: 546.5982142857143
        },
        {
          x: 642,
          y: 546.5982142857143
        },
        {
          x: 631.7142857142857,
          y: 551.1696428571429
        },
        {
          x: 623.7142857142857,
          y: 552.8839285714286
        },
        {
          x: 612.8571428571429,
          y: 551.1696428571429
        },
        {
          x: 606.5714285714286,
          y: 547.7410714285714
        },
        {
          x: 599.7142857142857,
          y: 542.5982142857143
        },
        {
          x: 584.2857142857143,
          y: 531.1696428571429
        },
        {
          x: 575.1428571428571,
          y: 536.3125
        },
        {
          x: 434.57142857142856,
          y: 448.88392857142856
        },
        {
          x: 426,
          y: 440.3125
        },
        {
          x: 419.7142857142857,
          y: 442.0267857142857
        },
        {
          x: 416.2857142857143,
          y: 446.5982142857143
        },
        {
          x: 431.14285714285717,
          y: 556.8839285714286
        },
        {
          x: 435.14285714285717,
          y: 585.4553571428571
        },
        {
          x: 439.7142857142857,
          y: 596.3125
        },
        {
          x: 442,
          y: 608.3125
        },
        {
          x: 445.42857142857144,
          y: 616.3125
        },
        {
          x: 453.42857142857144,
          y: 622.0267857142857
        },
        {
          x: 463.7142857142857,
          y: 633.4553571428571
        },
        {
          x: 464.2857142857143,
          y: 637.4553571428571
        },
        {
          x: 463.7142857142857,
          y: 640.8839285714286
        },
        {
          x: 462,
          y: 646.0267857142857
        },
        {
          x: 456.85714285714283,
          y: 647.7410714285714
        },
        {
          x: 462.57142857142856,
          y: 666.0267857142857
        },
        {
          x: 459.14285714285717,
          y: 675.1696428571429
        },
        {
          x: 457.42857142857144,
          y: 679.7410714285714
        },
        {
          x: 421.42857142857144,
          y: 680.3125
        },
        {
          x: 416.2857142857143,
          y: 684.8839285714286
        },
        {
          x: 416.2857142857143,
          y: 694.0267857142857
        },
        {
          x: 415.7142857142857,
          y: 714.0267857142857
        },
        {
          x: 412.85714285714283,
          y: 716.3125
        },
        {
          x: 414.57142857142856,
          y: 722.5982142857143
        },
        {
          x: 419.14285714285717,
          y: 722.5982142857143
        },
        {
          x: 420.85714285714283,
          y: 722.5982142857143
        },
        {
          x: 419.7142857142857,
          y: 729.4553571428571
        },
        {
          x: 416.2857142857143,
          y: 736.8839285714286
        },
        {
          x: 407.14285714285717,
          y: 738.5982142857143
        },
        {
          x: 403.7142857142857,
          y: 743.7410714285714
        },
        {
          x: 402,
          y: 750.0267857142857
        },
        {
          x: 400.85714285714283,
          y: 760.3125
        },
        {
          x: 380.2857142857143,
          y: 760.8839285714286
        },
        {
          x: 378,
          y: 756.8839285714286
        },
        {
          x: 378.57142857142856,
          y: 754.0267857142857
        },
        {
          x: 372.85714285714283,
          y: 752.3125
        },
        {
          x: 359.14285714285717,
          y: 752.3125
        },
        {
          x: 351.14285714285717,
          y: 751.7410714285714
        },
        {
          x: 344.2857142857143,
          y: 738.5982142857143
        },
        {
          x: 322,
          y: 687.1696428571429
        },
        {
          x: 334,
          y: 688.3125
        },
        {
          x: 335.14285714285717,
          y: 683.1696428571429
        },
        {
          x: 330,
          y: 678.5982142857143
        },
        {
          x: 320.2857142857143,
          y: 669.4553571428571
        },
        {
          x: 322,
          y: 658.0267857142857
        },
        {
          x: 327.14285714285717,
          y: 644.3125
        },
        {
          x: 332.2857142857143,
          y: 635.7410714285714
        },
        {
          x: 318.57142857142856,
          y: 503.16964285714283
        },
        {
          x: 315.14285714285717,
          y: 470.5982142857143
        },
        {
          x: 314.57142857142856,
          y: 434.5982142857143
        },
        {
          x: 312.85714285714283,
          y: 414.5982142857143
        },
        {
          x: 302.57142857142856,
          y: 403.74107142857144
        },
        {
          x: 301.42857142857144,
          y: 402.0267857142857
        },
        {
          x: 290.57142857142856,
          y: 391.74107142857144
        },
        {
          x: 287.14285714285717,
          y: 388.3125
        },
        {
          x: 284.2857142857143,
          y: 383.16964285714283
        },
        {
          x: 282.57142857142856,
          y: 375.16964285714283
        },
        {
          x: 280.85714285714283,
          y: 366.5982142857143
        },
        {
          x: 285.42857142857144,
          y: 356.3125
        },
        {
          x: 291.14285714285717,
          y: 346.0267857142857
        },
        {
          x: 302.57142857142856,
          y: 334.0267857142857
        },
        {
          x: 313.42857142857144,
          y: 324.88392857142856
        },
        {
          x: 326.57142857142856,
          y: 312.88392857142856
        },
        {
          x: 336.85714285714283,
          y: 307.74107142857144
        },
        {
          x: 354.57142857142856,
          y: 304.88392857142856
        },
        {
          x: 364.85714285714283,
          y: 304.88392857142856
        },
        {
          x: 371.7142857142857,
          y: 303.16964285714283
        },
        {
          x: 379.7142857142857,
          y: 302.5982142857143
        },
        {
          x: 392.2857142857143,
          y: 304.3125
        },
        {
          x: 400.85714285714283,
          y: 304.3125
        },
        {
          x: 406,
          y: 296.3125
        },
        {
          x: 414.57142857142856,
          y: 284.3125
        },
        {
          x: 421.42857142857144,
          y: 279.16964285714283
        },
        {
          x: 426.57142857142856,
          y: 280.88392857142856
        },
        {
          x: 424.85714285714283,
          y: 287.74107142857144
        },
        {
          x: 422.57142857142856,
          y: 295.74107142857144
        },
        {
          x: 416.2857142857143,
          y: 304.3125
        },
        {
          x: 414.57142857142856,
          y: 309.45535714285717
        },
        {
          x: 414.57142857142856,
          y: 315.16964285714283
        },
        {
          x: 418,
          y: 319.74107142857144
        },
        {
          x: 427.7142857142857,
          y: 326.5982142857143
        },
        {
          x: 434.57142857142856,
          y: 323.74107142857144
        },
        {
          x: 455.7142857142857,
          y: 318.0267857142857
        },
        {
          x: 463.7142857142857,
          y: 319.74107142857144
        },
        {
          x: 472.85714285714283,
          y: 322.0267857142857
        },
        {
          x: 491.14285714285717,
          y: 337.45535714285717
        },
        {
          x: 508.85714285714283,
          y: 354.5982142857143
        },
        {
          x: 515.1428571428571,
          y: 360.88392857142856
        },
        {
          x: 582,
          y: 428.3125
        },
        {
          x: 590.5714285714286,
          y: 432.88392857142856
        },
        {
          x: 608.2857142857143,
          y: 448.88392857142856
        },
        {
          x: 635.1428571428571,
          y: 471.16964285714283
        },
        {
          x: 645.4285714285714,
          y: 480.88392857142856
        },
        {
          x: 753.4285714285714,
          y: 479.16964285714283
        },
        {
          x: 754,
          y: 474.5982142857143
        },
        {
          x: 766,
          y: 474.0267857142857
        },
        {
          x: 769.4285714285714,
          y: 471.16964285714283
        },
        {
          x: 779.1428571428571,
          y: 468.88392857142856
        },
        {
          x: 782.5714285714286,
          y: 468.88392857142856
        },
        {
          x: 782.5714285714286,
          y: 474.0267857142857
        },
        {
          x: 788.2857142857143,
          y: 474.0267857142857
        },
        {
          x: 791.1428571428571,
          y: 474.5982142857143
        },
        {
          x: 791.7142857142857,
          y: 489.45535714285717
        },
        {
          x: 819.1428571428571,
          y: 488.3125
        },
        {
          x: 820.8571428571429,
          y: 491.16964285714283
        },
        {
          x: 818.5714285714286,
          y: 491.74107142857144
        },
        {
          x: 767.7142857142857,
          y: 493.45535714285717
        },
        {
          x: 766,
          y: 493.45535714285717
        },
        {
          x: 766,
          y: 505.45535714285717
        },
        {
          x: 820.8571428571429,
          y: 504.88392857142856
        }
      ],
      label: 'robot blue',
      complete: true
    },
    {
      key: 'ee7eef57-784c-426b-b8f1-39bb0ebba07e',
      vertices: [
        {
          x: 727.2,
          y: 532.61875
        },
        {
          x: 843.6,
          y: 524.21875
        },
        {
          x: 848.4,
          y: 514.61875
        },
        {
          x: 851.2,
          y: 508.21875
        },
        {
          x: 852,
          y: 497.81875
        },
        {
          x: 850,
          y: 488.21875
        },
        {
          x: 848.4,
          y: 481.81875
        },
        {
          x: 842.8,
          y: 473.81875
        },
        {
          x: 840.4,
          y: 467.41875
        },
        {
          x: 836.8,
          y: 460.21875
        },
        {
          x: 835.2,
          y: 448.61875
        },
        {
          x: 833.2,
          y: 423.41875
        },
        {
          x: 830.8,
          y: 397.81875
        },
        {
          x: 830.4,
          y: 382.21875
        },
        {
          x: 826.8,
          y: 371.41875
        },
        {
          x: 828,
          y: 370.61875
        },
        {
          x: 865.6,
          y: 397.01875
        },
        {
          x: 871.6,
          y: 401.41875
        },
        {
          x: 877.6,
          y: 403.01875
        },
        {
          x: 893.2,
          y: 410.21875
        },
        {
          x: 907.6,
          y: 417.01875
        },
        {
          x: 914.8,
          y: 422.21875
        },
        {
          x: 918.4,
          y: 424.21875
        },
        {
          x: 924.4,
          y: 425.41875
        },
        {
          x: 935.2,
          y: 427.01875
        },
        {
          x: 940.8,
          y: 425.81875
        },
        {
          x: 944.8,
          y: 424.61875
        },
        {
          x: 950.8,
          y: 424.21875
        },
        {
          x: 955.6,
          y: 424.21875
        },
        {
          x: 959.2,
          y: 423.41875
        },
        {
          x: 967.6,
          y: 421.01875
        },
        {
          x: 971.2,
          y: 423.01875
        },
        {
          x: 978.4,
          y: 423.41875
        },
        {
          x: 979.6,
          y: 441.01875
        },
        {
          x: 999.6,
          y: 441.01875
        },
        {
          x: 1000.8,
          y: 449.41875
        },
        {
          x: 998.4,
          y: 449.81875
        },
        {
          x: 998.8,
          y: 461.41875
        },
        {
          x: 1001.2,
          y: 463.81875
        },
        {
          x: 1002,
          y: 467.41875
        },
        {
          x: 1004.4,
          y: 467.41875
        },
        {
          x: 1006,
          y: 464.21875
        },
        {
          x: 1007.2,
          y: 461.81875
        },
        {
          x: 1006.8,
          y: 456.61875
        },
        {
          x: 1006.8,
          y: 448.61875
        },
        {
          x: 1004.8,
          y: 448.21875
        },
        {
          x: 1005.6,
          y: 442.21875
        },
        {
          x: 1010.4,
          y: 441.01875
        },
        {
          x: 1010.8,
          y: 437.41875
        },
        {
          x: 1007.2,
          y: 431.41875
        },
        {
          x: 1006,
          y: 427.81875
        },
        {
          x: 1006.8,
          y: 405.01875
        },
        {
          x: 1020.4,
          y: 405.41875
        },
        {
          x: 1024,
          y: 408.61875
        },
        {
          x: 1030.8,
          y: 408.61875
        },
        {
          x: 1033.2,
          y: 410.21875
        },
        {
          x: 1037.2,
          y: 411.01875
        },
        {
          x: 1041.6,
          y: 411.01875
        },
        {
          x: 1041.6,
          y: 408.61875
        },
        {
          x: 1048.8,
          y: 408.61875
        },
        {
          x: 1049.2,
          y: 398.21875
        },
        {
          x: 1069.2,
          y: 399.01875
        },
        {
          x: 1072.8,
          y: 397.81875
        },
        {
          x: 1071.6,
          y: 394.61875
        },
        {
          x: 1030,
          y: 394.61875
        },
        {
          x: 1030,
          y: 387.01875
        },
        {
          x: 1073.2,
          y: 388.21875
        },
        {
          x: 1072,
          y: 383.81875
        },
        {
          x: 1049.2,
          y: 382.61875
        },
        {
          x: 1050,
          y: 375.41875
        },
        {
          x: 1044.4,
          y: 373.01875
        },
        {
          x: 1040.4,
          y: 369.01875
        },
        {
          x: 1034.8,
          y: 369.01875
        },
        {
          x: 1033.2,
          y: 369.01875
        },
        {
          x: 1032,
          y: 373.01875
        },
        {
          x: 1021.2,
          y: 373.01875
        },
        {
          x: 1021.2,
          y: 377.41875
        },
        {
          x: 1008,
          y: 377.81875
        },
        {
          x: 1008,
          y: 365.41875
        },
        {
          x: 1004.4,
          y: 361.81875
        },
        {
          x: 1003.2,
          y: 364.61875
        },
        {
          x: 1001.2,
          y: 368.21875
        },
        {
          x: 997.6,
          y: 366.61875
        },
        {
          x: 996.4,
          y: 361.01875
        },
        {
          x: 992.8,
          y: 362.21875
        },
        {
          x: 989.2,
          y: 360.61875
        },
        {
          x: 978,
          y: 352.21875
        },
        {
          x: 953.2,
          y: 341.41875
        },
        {
          x: 927.6,
          y: 337.01875
        },
        {
          x: 902.8,
          y: 333.41875
        },
        {
          x: 894,
          y: 329.81875
        },
        {
          x: 882,
          y: 323.41875
        },
        {
          x: 875.2,
          y: 316.21875
        },
        {
          x: 870.4,
          y: 308.21875
        },
        {
          x: 864.4,
          y: 303.01875
        },
        {
          x: 862,
          y: 291.41875
        },
        {
          x: 856.8,
          y: 275.81875
        },
        {
          x: 849.6,
          y: 269.41875
        },
        {
          x: 838,
          y: 267.41875
        },
        {
          x: 830.8,
          y: 271.81875
        },
        {
          x: 824.8,
          y: 278.21875
        },
        {
          x: 821.2,
          y: 279.01875
        },
        {
          x: 817.6,
          y: 274.61875
        },
        {
          x: 812.8,
          y: 269.41875
        },
        {
          x: 808,
          y: 267.41875
        },
        {
          x: 800.4,
          y: 265.01875
        },
        {
          x: 801.6,
          y: 259.81875
        },
        {
          x: 802.8,
          y: 251.41875
        },
        {
          x: 800.4,
          y: 246.61875
        },
        {
          x: 792,
          y: 250.21875
        },
        {
          x: 788.4,
          y: 257.41875
        },
        {
          x: 786.4,
          y: 263.41875
        },
        {
          x: 780.4,
          y: 262.61875
        },
        {
          x: 772.8,
          y: 261.41875
        },
        {
          x: 762,
          y: 261.41875
        },
        {
          x: 753.6,
          y: 268.21875
        },
        {
          x: 748.8,
          y: 267.41875
        },
        {
          x: 744,
          y: 268.21875
        },
        {
          x: 739.2,
          y: 273.01875
        },
        {
          x: 720,
          y: 303.01875
        },
        {
          x: 721.2,
          y: 309.41875
        },
        {
          x: 722.4,
          y: 317.41875
        },
        {
          x: 727.2,
          y: 321.41875
        },
        {
          x: 726,
          y: 333.01875
        },
        {
          x: 728.8,
          y: 400.61875
        },
        {
          x: 733.2,
          y: 433.81875
        },
        {
          x: 734.4,
          y: 445.01875
        },
        {
          x: 736.8,
          y: 471.01875
        },
        {
          x: 738,
          y: 477.01875
        },
        {
          x: 739.2,
          y: 479.41875
        },
        {
          x: 752.4,
          y: 478.61875
        },
        {
          x: 754,
          y: 473.41875
        },
        {
          x: 762.4,
          y: 474.61875
        },
        {
          x: 768.4,
          y: 472.21875
        },
        {
          x: 778.8,
          y: 468.61875
        },
        {
          x: 782.4,
          y: 468.61875
        },
        {
          x: 782.8,
          y: 473.41875
        },
        {
          x: 789.6,
          y: 472.61875
        },
        {
          x: 792.4,
          y: 487.01875
        },
        {
          x: 792,
          y: 487.81875
        },
        {
          x: 820,
          y: 487.81875
        },
        {
          x: 822,
          y: 491.41875
        },
        {
          x: 823.2,
          y: 509.41875
        },
        {
          x: 821.2,
          y: 509.81875
        },
        {
          x: 791.2,
          y: 509.81875
        },
        {
          x: 790.8,
          y: 515.41875
        },
        {
          x: 790.8,
          y: 521.81875
        },
        {
          x: 785.2,
          y: 523.81875
        },
        {
          x: 765.6,
          y: 526.21875
        },
        {
          x: 763.2,
          y: 523.81875
        },
        {
          x: 755.2,
          y: 523.01875
        },
        {
          x: 752.8,
          y: 519.01875
        },
        {
          x: 723.6,
          y: 519.01875
        },
        {
          x: 718.8,
          y: 520.21875
        },
        {
          x: 720.4,
          y: 528.61875
        },
        {
          x: 722.4,
          y: 534.61875
        }
      ],
      label: 'robot blue',
      complete: true
    },
    {
      key: '42a1dd54-b7fa-40f5-8603-473251f6f512',
      vertices: [
        {
          x: 1375.011676389915,
          y: 854.546875
        },
        {
          x: 1351,
          y: 854.546875
        },
        {
          x: 1332,
          y: 856.546875
        },
        {
          x: 1330,
          y: 845.546875
        },
        {
          x: 1315,
          y: 844.546875
        },
        {
          x: 1294,
          y: 842.546875
        },
        {
          x: 1293,
          y: 838.546875
        },
        {
          x: 1282,
          y: 838.546875
        },
        {
          x: 1281,
          y: 832.546875
        },
        {
          x: 1182,
          y: 833.546875
        },
        {
          x: 1179,
          y: 796.546875
        },
        {
          x: 1179,
          y: 778.546875
        },
        {
          x: 1183,
          y: 763.546875
        },
        {
          x: 1189,
          y: 761.546875
        },
        {
          x: 1192,
          y: 763.546875
        },
        {
          x: 1192,
          y: 767.546875
        },
        {
          x: 1279,
          y: 770.546875
        },
        {
          x: 1303,
          y: 751.546875
        },
        {
          x: 1318,
          y: 751.546875
        },
        {
          x: 1329,
          y: 751.546875
        },
        {
          x: 1342,
          y: 745.546875
        },
        {
          x: 1354,
          y: 742.546875
        },
        {
          x: 1356,
          y: 730.546875
        },
        {
          x: 1356,
          y: 676.546875
        },
        {
          x: 1360,
          y: 596.546875
        },
        {
          x: 1371,
          y: 524.546875
        },
        {
          x: 1369,
          y: 517.546875
        },
        {
          x: 1374,
          y: 502.546875
        },
        {
          x: 1359,
          y: 425.546875
        },
        {
          x: 1347,
          y: 338.546875
        },
        {
          x: 1345,
          y: 320.546875
        },
        {
          x: 1344,
          y: 307.546875
        },
        {
          x: 1344,
          y: 296.546875
        },
        {
          x: 1347,
          y: 283.546875
        },
        {
          x: 1354,
          y: 275.546875
        },
        {
          x: 1363,
          y: 268.546875
        },
        {
          x: 1375,
          y: 265.546875
        },
        {
          x: 1390,
          y: 262.546875
        },
        {
          x: 1393,
          y: 247.546875
        },
        {
          x: 1396,
          y: 224.546875
        },
        {
          x: 1413,
          y: 205.546875
        },
        {
          x: 1431,
          y: 187.546875
        },
        {
          x: 1447,
          y: 181.546875
        },
        {
          x: 1504,
          y: 182.546875
        },
        {
          x: 1516,
          y: 199.546875
        },
        {
          x: 1536,
          y: 221.546875
        },
        {
          x: 1546,
          y: 244.546875
        },
        {
          x: 1564,
          y: 248.546875
        },
        {
          x: 1573,
          y: 253.546875
        },
        {
          x: 1576,
          y: 260.546875
        },
        {
          x: 1590,
          y: 265.546875
        },
        {
          x: 1596,
          y: 290.546875
        },
        {
          x: 1603,
          y: 341.546875
        },
        {
          x: 1608,
          y: 388.546875
        },
        {
          x: 1614,
          y: 458.546875
        },
        {
          x: 1617,
          y: 509.546875
        },
        {
          x: 1615,
          y: 550.546875
        },
        {
          x: 1614,
          y: 562.546875
        },
        {
          x: 1605,
          y: 568.546875
        },
        {
          x: 1591,
          y: 572.546875
        },
        {
          x: 1581,
          y: 569.546875
        },
        {
          x: 1567,
          y: 577.546875
        },
        {
          x: 1567,
          y: 602.546875
        },
        {
          x: 1564,
          y: 629.546875
        },
        {
          x: 1564,
          y: 656.546875
        },
        {
          x: 1567,
          y: 683.546875
        },
        {
          x: 1590,
          y: 682.546875
        },
        {
          x: 1606,
          y: 685.546875
        },
        {
          x: 1623,
          y: 688.546875
        },
        {
          x: 1627,
          y: 703.546875
        },
        {
          x: 1635,
          y: 761.546875
        },
        {
          x: 1639,
          y: 812.546875
        },
        {
          x: 1635,
          y: 890.546875
        },
        {
          x: 1444,
          y: 895.546875
        },
        {
          x: 1446,
          y: 827.546875
        },
        {
          x: 1434,
          y: 820.546875
        },
        {
          x: 1405,
          y: 814.546875
        },
        {
          x: 1389,
          y: 814.546875
        },
        {
          x: 1375,
          y: 815.546875
        },
        {
          x: 1369,
          y: 821.546875
        },
        {
          x: 1365,
          y: 833.546875
        },
        {
          x: 1369,
          y: 841.546875
        },
        {
          x: 1372,
          y: 841.546875
        }
      ],
      label: 'robot blank',
      complete: true
    },
    {
      key: 'cf62e250-df26-4606-8a49-d82f78dfa6d9',
      vertices: [
        {
          x: 475,
          y: 947.546875
        },
        {
          x: 265,
          y: 947.546875
        },
        {
          x: 264,
          y: 928.546875
        },
        {
          x: 261,
          y: 916.546875
        },
        {
          x: 255,
          y: 910.546875
        },
        {
          x: 246,
          y: 899.546875
        },
        {
          x: 231,
          y: 893.546875
        },
        {
          x: 229,
          y: 800.546875
        },
        {
          x: 237,
          y: 790.546875
        },
        {
          x: 237,
          y: 778.546875
        },
        {
          x: 289,
          y: 850.546875
        },
        {
          x: 298,
          y: 853.546875
        },
        {
          x: 313,
          y: 856.546875
        },
        {
          x: 334,
          y: 854.546875
        },
        {
          x: 346,
          y: 845.546875
        },
        {
          x: 354,
          y: 836.546875
        },
        {
          x: 376,
          y: 833.546875
        },
        {
          x: 382,
          y: 829.546875
        },
        {
          x: 396,
          y: 830.546875
        },
        {
          x: 396,
          y: 892.546875
        },
        {
          x: 396,
          y: 919.546875
        },
        {
          x: 396,
          y: 934.546875
        },
        {
          x: 477,
          y: 932.546875
        }
      ],
      label: 'robot blue',
      complete: false
    }
  ]
};

export default () => (
  <TaskResponsePolygonAnnotation
    hover
    imageURL="/static/img/website/solutions/robotics/slider/slide-2.jpg"
    annotations={response.annotations}
    bgTransparent
    responsive
    rounded
  />
);
